const LEGACY_HYPHEN_PREFIX_SEGMENTS = 6;

const isLikelyBareUuid = (value: string): boolean =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value.trim());

const decodeUriComponent = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

const displayNameFromObjectKey = (key: string): string | undefined => {
  const segments = key.split('/').filter(Boolean);
  const last = segments[segments.length - 1];
  if (!last) return undefined;

  const root = segments[0];
  if (root === 'documents' || root === 'images') {
    if (segments.length >= 3) {
      return decodeUriComponent(last);
    }
    if (segments.length === 2 && isLikelyBareUuid(last)) {
      return undefined;
    }
    return decodeUriComponent(last);
  }

  const hyphenParts = last.split('-');
  if (hyphenParts.length > LEGACY_HYPHEN_PREFIX_SEGMENTS) {
    return decodeUriComponent(hyphenParts.slice(LEGACY_HYPHEN_PREFIX_SEGMENTS).join('-'));
  }

  return decodeUriComponent(last);
};

const normalizeFileDisplayName = (value: string | undefined): string | undefined => {
  const trimmed = value?.trim();
  if (!trimmed) return undefined;

  const display = displayNameFromObjectKey(trimmed);
  if (!display || isLikelyBareUuid(display)) return undefined;

  return display;
};

export const getS3FileOriginalName = (storedUrl?: string): string | undefined => {
  if (!storedUrl?.trim()) return undefined;

  const fromEncodedObjectKey = (encodedKey: string): string | undefined => {
    if (!encodedKey) return undefined;
    try {
      return displayNameFromObjectKey(decodeURIComponent(encodedKey));
    } catch {
      return displayNameFromObjectKey(encodedKey);
    }
  };

  try {
    const u = new URL(storedUrl);
    const encodedKey = u.pathname.startsWith('/') ? u.pathname.slice(1) : u.pathname;
    return fromEncodedObjectKey(encodedKey.split('?')[0]);
  } catch {
    const tail = storedUrl.split('/').pop();
    return tail ? fromEncodedObjectKey(tail.split('?')[0]) : undefined;
  }
};

export const resolveVaultDisplayName = (storedName: string | undefined, link: string): string => {
  const fromStored = normalizeFileDisplayName(storedName);
  const fromLink = normalizeFileDisplayName(getS3FileOriginalName(link));

  return fromStored || fromLink || 'file';
};
